import { render, staticRenderFns } from "./UserToolbar.vue?vue&type=template&id=32552d74&"
import script from "./UserToolbar.vue?vue&type=script&lang=js&"
export * from "./UserToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports